import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	carouselTitle: {
		id: 'company-hub.carousel-extension.hub-element.title',
		defaultMessage: 'Carousel',
		description: 'A visible text label to be used as the title for the carousel element',
	},
	carouselDescription: {
		id: 'company-hub.carousel-extension.hub-element.description',
		defaultMessage: 'A rotating set of beautiful frames',
		description: 'A visible text label to be used as the description for the carousel element',
	},
});
